
import AssociaUsuarioGrupo from './AssociaUsuarioGrupo';
import AtualizaGraficos from './AtualizaGraficos';
import CadastraPontoFacultativo from './CadastraPontoFacultativo';
import ConsultaPontoFacultativo from './ConsultaPontoFacultativo';
import IndicadorAjusteExcepcional from './IndicadorAjusteExcepcional';

export const MENU_CONFIGURACOES = [
  {
    'id': 1,
    'nome': 'Usuário',
    'submenus': [
      {
        'id': 1.1,
        'nome': 'Grupo de Usuário (Permissões)',
        componente: AssociaUsuarioGrupo
      }
    ]
  },
  {
    'id': 2,
    'nome': 'Gráficos',
    'submenus': [
      {
        'id': 2.1,
        'nome': 'Atualizar',
        componente: AtualizaGraficos
      }
    ]
  },
  {
    'id': 3,
    'nome': 'Ponto Facultativo',
    'submenus': [
      {
        'id': 3.1,
        'nome': 'Cadastrar',
        componente: CadastraPontoFacultativo
      },
      {
        'id': 3.2,
        'nome': 'Consultar',
        componente: ConsultaPontoFacultativo
      }
    ]
  },
  {
    'id': 4,
    'nome': 'Indicador',
    'submenus': [
      {
        'id': 4.1,
        'nome': 'Ajuste Excepcional',
        componente: IndicadorAjusteExcepcional
      }
    ]
  },
]
